import React from 'react';

import { useLocationPath } from 'app/modules/Navigation/utils';
import ErrorBoundary from 'app/widgets/ErrorBoundary';
import NotFound from 'app/widgets/Errors/NotFound';

import { MatchCenter } from '../MatchCenter';
import { Sport } from '../Sport';
import { SportRedirect } from '../SportRedirect';

export const Content: React.FC<PrematchContentProps> = () => {
  const { list, sportId, matchId } = useLocationPath();

  if (matchId) {
    return (
      <ErrorBoundary>
        <MatchCenter />
      </ErrorBoundary>
    );
  }

  if (sportId && !list) {
    return (
      <ErrorBoundary>
        <Sport sportId={sportId} />
      </ErrorBoundary>
    );
  }

  switch (list) {
    case null:
      return (
        <ErrorBoundary>
          <SportRedirect />
        </ErrorBoundary>
      );

    default:
      return <NotFound />;
  }
};
